import sanityClient from "@sanity/client";

export default sanityClient({
    projectId: "9cs54w69",
    dataset: "production"
})